import { window } from "./window.js";
export const { EventSource, EventTarget, CustomEvent, Node, Comment, Text, Element, HTMLElement, HTMLInputElement, HTMLTemplateElement, HTMLScriptElement, InputEvent, Document, DocumentFragment, DOMParser, Promise, Map, WeakMap, Set, WeakSet, Error, ReferenceError, TypeError, } = window;
const TYPEOF_STRING = "string";
const TYPEOF_OBJECT = "object";
const TYPEOF_BOOLEAN = "boolean";
const NODETYPE = "nodeType";
export const TAGNAME_TEMPLATE = "template";
export const TAGNAME_INPUT = "input";
export const TAGNAME_DETAILS = "details";
export const noop = () => { };
export const isBoolean = (val) => typeof val === TYPEOF_BOOLEAN;
export const isString = (val) => typeof val === TYPEOF_STRING;
export const isObject = (val) => typeof val === TYPEOF_OBJECT && val !== null;
export const isNull = (val) => val === null;
export const isUndefined = (val) => val === undefined;
export const isDefined = (val) => val !== undefined;
export const isInstanceOf = (val, constructor) => val instanceof constructor;
export const isPrototypeOf = (proto, val) => val === null || val === undefined ? false : Object.prototype.isPrototypeOf.call(proto, val);
export const isElementNode = (node) => node[NODETYPE] === 1;
export const isTextNode = (node) => node[NODETYPE] === 3;
export const isCommentNode = (node) => node[NODETYPE] === 8;
export const isDocumentNode = (node) => node[NODETYPE] === 9;
export const isDocumentFragmentNode = (node) => node[NODETYPE] === 11;
